<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3212_101645)">
<rect x="0.85" y="7.35" width="20.3" height="7.3" rx="3.65" stroke="currentColor" stroke-width="1.7"/>
<rect x="5.20001" y="15.5" width="9" height="1.4" transform="rotate(-90 5.20001 15.5)" fill="currentColor"/>
<rect x="8.59998" y="9.53973" width="1.4" height="2.92048" fill="currentColor"/>
<rect x="12" y="9.53973" width="1.4" height="2.92048" fill="currentColor"/>
<rect x="15.4" y="15.5" width="9" height="1.4" transform="rotate(-90 15.4 15.5)" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_3212_101645">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
